import { SessionExpiredError } from "../services/api/client";

/** What to tell someone whose session has ended. The banner at the top of the page explains it and offers to sign in. */
export const SESSION_EXPIRED_MESSAGE = "Your session expired. Sign in again to continue.";

/** True if a failed request failed because the person's session ended, rather than for some other reason. */
export const isSessionExpiredError = (err) => err instanceof SessionExpiredError || err?.code === "SESSION_EXPIRED";

/**
 * The message to show when something failed to load. Screens that used to show only a generic "Failed to load
 * ..." can use this so a session that ended is called out as such instead of looking like a broken page.
 */
export const loadErrorMessage = (err, fallback) => (isSessionExpiredError(err) ? SESSION_EXPIRED_MESSAGE : fallback);
